import { gql } from 'apollo-angular';

export const SendMessageDocument = gql`
  mutation sendMessage($input: SendMessageInputGraphql!) {
    sendMessage(input: $input)
  }
`;
